import React, { useMemo } from "react";
import Select from "react-select";
import { COLORS } from "../constants/colors";

const MultiSelectDropdown = ({
  options = [],
  selectedItems = [],
  onChange,
  placeholder = "Select options",
}) => {

  const selectOptions = useMemo(() => {
    return options.map((opt) =>
      typeof opt === "string"
        ? { label: opt, value: { id: opt, name: opt } }
        : { label: opt.name, value: opt }
    );
  }, [options]);

  const selectValue = useMemo(() => {
    return selectedItems.map((item) => ({
      label: item.name,
      value: item,
    }));
  }, [selectedItems]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 42,
      borderRadius: 8,
      fontSize: 14,
      borderColor: "#D1D5DB",
      boxShadow: "none",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: COLORS.PRIMARY_LIGHT,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: COLORS.PRIMARY,
      fontWeight: 500,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: COLORS.PRIMARY,
      ":hover": { opacity: 0.7 },
    }),
  };

  return (
    <Select
      isMulti
      options={selectOptions}
      value={selectValue}
      placeholder={placeholder}
      styles={selectStyles}
      closeMenuOnSelect={false}
      onChange={(items) => {
        onChange(items.map((i) => i.value));
      }}
    />
  );
};

export default MultiSelectDropdown;
